import { isValidPhoneNumber } from 'libphonenumber-js';
import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function phoneField(t: TranslateFn): z.ZodEffects<z.ZodString, string, string> {
    return z.string().refine(isValidPhoneNumber, t('validation.phone'));
}
